import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import routes from "router/routes";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";

import { getAuthInfo } from "store/slices/auth";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import styles from "assets/jss/material-dashboard-react/layouts/userStyle.js";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import AdminSideBar from "../components/Sidebar/AdminSideBar";
import AppColor from "../utilities/AppColor";
import { Helmet } from "react-helmet";
import AppUtil from "../utilities/AppUtil";
import AppConfig, { SYSTEM_ROLE } from "config/AppConfig";
import classNames from "classnames";
import { Box, Typography } from "@material-ui/core";
// import { el } from "date-fns/locale";
import { ADMIN_PERMISSIONS } from "config/AppConfig";
import moment from "moment";
import { fetchCompanyDetail } from "store/slices/company";
import { setSearchWorkerQueries } from "store/slices/worker";
// import { useMedia } from "react-use";
const { APPROVAL_STATUS } = AppConfig;



const Admin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const authInfo = useSelector(getAuthInfo) || {};
  const [companySubscription, setCompanySubscription] = useState({
    name: "",
    expiredDate: "",
  });



  const [mobileOpen, setMobileOpen] = useState(true);
  const handleDrawerToggle = () => {
    console.log('here');
    setMobileOpen(!mobileOpen);
  };
  const [isExpired, setExpired] = useState(false);
  const pathname = window.location.pathname;


  const useStyles = makeStyles((theme) => ({
    ...styles(theme),
    adminContent: {
      // padding: "1rem",
      margin: "15px",
      backgroundColor: "#f9f7f6",
      // boxShadow:
      //   "0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px 4px 4px rgba(0, 0, 0, 0.25)",
      // borderRadius: "21px",
      // overflow: 'scroll',
      height: 'max-content'
    },
    titleContainer: {
      margin: "15px 15px 0",
    },
    title: {
      fontSize: "28px",
      fontWeight: "bold",
      color: "#2dd4bf",
    },
    console: {
      height: isMobile ? '110vh' : "100vh",
      paddingTop: 50,
      display: "flex",
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        authInfo &&
        authInfo.role === SYSTEM_ROLE.COMPANY &&
        authInfo.companySubcriptionExpiryDate
      ) {
        const _expiredDate = moment(authInfo.companySubcriptionExpiryDate);
        const currentDate = moment();
        // console.log('check', _expiredDate.diff(currentDate));
        if (_expiredDate.diff(currentDate) > 0) {
          setExpired(false);
        } else {
          setExpired(true);
          clearInterval(interval);
        }
      }
    }, 100);
    if (
      authInfo &&
      authInfo.companySubcriptionExpiryDate &&
      authInfo.companySubscriptionName
    ) {
      setCompanySubscription({
        name: authInfo.companySubscriptionName,
        expiredDate: authInfo.companySubcriptionExpiryDate,
      });
    }
  }, [authInfo]);

  useEffect(() => {
    if (authInfo && authInfo.role === SYSTEM_ROLE.COMPANY) {
      dispatch(fetchCompanyDetail({ companyId: authInfo.companyId }));
    }
  }, [authInfo]);

  /**
   * Filter out inaccessible menu
   * @param e
   * @returns {boolean}
   */
  const menuFilter = (e) => {
    if (authInfo.role === SYSTEM_ROLE.SUPER_ADMIN) {
      if (e.permission) {
        return (
          e.layout === "/admin" &&
          !e.path.includes("participants") &&
          !e.path.includes("workers") &&
          !e.path.includes("booking") &&
          !e.path.includes("billing") &&
          !e.path.includes("payroll") &&
          !e.path.includes("jobs") &&
          !e.path.includes("subscriptions") &&
          !e.path.includes("rates")
        );
      } else {
        // return e.layout === "/admin" && !e.path.includes("account");
        return e.layout === "/admin" && e.path !== '/setting/account' && e.path !== '/setting-accounting' && !e.path.includes('financial') && !e.path.includes('/settings/options') && !e.path.includes('search-worker');
      }
    } else if (authInfo.role === SYSTEM_ROLE.MANAGER) {
      if (e.permission) {
        if (!authInfo.permissions) {
          return;
        } else {
          return (
            e.layout === "/admin" && authInfo.permissions.includes(e.permission)
          );
        }
      } else {
        // return e.layout === "/admin" && !e.path.includes("account");
        return e.layout === "/admin" && e.path !== '/setting/account' && e.path !== '/setting-accounting' && !e.path.includes('financial') && !e.path.includes('/settings/options') && !e.path.includes('search-worker');
      }
    } else if (authInfo.role === SYSTEM_ROLE.COMPANY) {
      if (authInfo.owner) {
        if (authInfo.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
          return e.layout === "/admin" && e.path.includes("profile");
        } else {
          if (e.permission) {
            if (!authInfo.permissions) {
              return;
            } else {
              // if (isExpired) {
              //   return (
              //     e.layout === "/admin" &&
              //     authInfo.permissions.includes(e.permission) &&
              //     !e.path.includes("users") &&
              //     !e.path.includes("jobs") &&
              //     !e.path.includes("workers") &&
              //     !e.path.includes("clients") &&
              //     !e.path.includes("rates") &&
              //     !e.path.includes("booking") &&
              //     !e.path.includes("billing") &&
              //     !e.path.includes("payroll")
              //   );
              // } else {
                return (
                  e.layout === "/admin" &&
                  authInfo.permissions.includes(e.permission)
                );
              // }
            }
          } else {
            return e.layout === "/admin";
          }
        }
      } else {
        if (e.permission) {
          if (!authInfo.permissions) {
            return;
          } else {
            return (
              e.layout === "/admin" &&
              authInfo.permissions.includes(e.permission)
            );
          }
        } else {
          // return e.layout === "/admin" && !e.path.includes("account");
          return e.layout === "/admin" && e.path !== '/setting/account' && e.path !== '/setting-accounting';
        }
      }
    }
  };

  useEffect(() => {
    if (pathname === '/admin/search-worker') {
      if (!history.location.state) {
        dispatch(setSearchWorkerQueries({
          page: 1,
          size: 20,
          accreditationIds: [],
          genders: [],
          languageIds: [],
          lat: '',
          lng: '',
          specialtyIds: [],
          supportIds: [],
          search: ''
      }));
      }
    }
    if (!pathname.includes('/admin/search-worker')) {
      dispatch(setSearchWorkerQueries({
          page: 1,
          size: 20,
          accreditationIds: [],
          genders: [],
          languageIds: [],
          lat: '',
          lng: '',
          specialtyIds: [],
          supportIds: [],
          search: ''
      }))
    }
  }, [pathname]);

  useEffect(() => {
    if (
      authInfo.role !== SYSTEM_ROLE.SUPER_ADMIN &&
      authInfo.role !== SYSTEM_ROLE.MANAGER &&
      authInfo.role !== SYSTEM_ROLE.COMPANY
    ) {
      history.push("/dashboard");
    }
  }, [authInfo]);

  useEffect(() => {
    if (authInfo.role === SYSTEM_ROLE.MANAGER) {
      handlePermissionManager();
    }
    if (authInfo.role === SYSTEM_ROLE.COMPANY && authInfo.owner) {
        if (authInfo.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
          history.push("/admin/profile");
        } else {
          // history.push("/admin/dashboard");
        }
    } 
    if (authInfo.role === SYSTEM_ROLE.COMPANY && !authInfo.owner) {
      handlePermissionCompanyUser();
    }
  }, []);

  const handlePermissionManager = () => {
    const currentPath = history.location.pathname;
    let path = "/admin/profile";
    if (authInfo.permissions) {
      if (authInfo.permissions.indexOf(ADMIN_PERMISSIONS.dashboard.id) > -1) {
        path = "/admin/dashboard";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.users.id) > -1
      ) {
        path = "/admin/users";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.company.id) > -1
      ) {
        path = "/admin/company";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.subscriptionPlan.id) > -1
      ) {
        path = "/admin/subscription-plan";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.transactions.id) > -1
      ) {
        path = "/admin/transactions";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.accountSoftware.id) > -1
      ) {
        path = "/admin/account-software";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.paymentGateway.id) > -1
      ) {
        path = "/admin/payment-gateway";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.options.id) > -1
      ) {
        path = "/admin/options";
      }
      if (currentPath === "/admin/dashboard" && currentPath !== path) {
        history.push(path);
      }
    }
  };

  const handlePermissionCompanyUser = () => {
    let path = "/admin/profile";
    const currentPath = history.location.pathname;
    if (authInfo.permissions) {
      if (authInfo.permissions.indexOf(ADMIN_PERMISSIONS.dashboard.id) > -1) {
        path = "/admin/dashboard";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.users.id) > -1
      ) {
        path = "/admin/users";
      } else if (authInfo.permissions.indexOf(ADMIN_PERMISSIONS.jobs.id) > -1) {
        path = "/admin/jobs";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.workers.id) > -1
      ) {
        path = "/admin/workers";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.clients.id) > -1
      ) {
        path = "/admin/participants";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.rates.id) > -1
      ) {
        path = "/admin/rates";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.booking.id) > -1
      ) {
        path = "/admin/booking";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.billing.id) > -1
      ) {
        path = "/admin/billing";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.payroll.id) > -1
      ) {
        path = "/admin/payroll";
      } else if (
        authInfo.permissions.indexOf(ADMIN_PERMISSIONS.subscriptions.id) > -1
      ) {
        path = "/admin/subscriptions";
      }
      if (currentPath === "/admin/dashboard" && currentPath !== path) {
        history.push(path);
      }
    } else {
      history.push(path);
    }
  };

  const switchRoutes = (
    <Switch>
      {routes.filter(menuFilter).map((route, key) => {
        return (
          <Route
            path={`${route.layout}${route.path}`}
            component={(props) => (
              <React.Fragment>
                { authInfo.role === SYSTEM_ROLE.COMPANY && <Typography
                  style={{ color: (isExpired && authInfo.role === SYSTEM_ROLE.COMPANY) ? AppColor.red : AppColor.orange, marginTop: '10px' }}
                  align="center"
                >
                  {(isExpired && authInfo.role === SYSTEM_ROLE.COMPANY)
                    ? `${t(
                      "text.expired_date_subscription"
                    )}
                    ${companySubscription.name}
                    ${t("text.expired_date_subscription_2")}
                    ${AppUtil.formatDate(
                      companySubscription.expiredDate,
                      "MM/DD/YYYY HH:mm:ss"
                    )}${t("text.expired_date_subscription_3")}`
                    : ''}
                </Typography>}
                <div className={classes.titleContainer}>
                  <h3 className={classes.title}>
                    {t(route.extraTitle ? route.extraTitle : route.name)}
                  </h3>
                </div>
                <div className={`${classes.adminContent}`}>
                  <route.component {...props} />
                </div>
              </React.Fragment>
            )}
            key={key}
            exact
          />
        );
      })}
      <Redirect from="/admin" to="/admin/dashboard" />
    </Switch>
  );

  // const resizeFunction = () => {
  //   if (window.innerWidth < 600) {
  //     setMobileOpen(false);
  //   } else {
  //     console.log('here');
  //     setMobileOpen(true);
  //   }
  // };

  // useEffect(() => {
  //   // if (AppUtil.mobileAndTabletCheck()) {
  //   //   alert('ok');
  //   // }
  //   window.addEventListener("resize", resizeFunction);
  //   return () => {
  //     window.removeEventListener("resize", resizeFunction);
  //   };

  // }, []);
  // console.log('isMobile', isMobile);
  return (
    <PerfectScrollbar
      className={classNames({
        "user-console": true,
        [classes.console]: true,
        [classes.customs]: isMobile
      })}
      options={{
        // suppressScrollX: true,
        suppressScrollY: false,
      }}
      id="main-panel"
    >
      <Helmet>
        <title>{AppUtil.makeBrand(routes)}</title>
        {/* {isMobile &&  <meta name="viewport" content="width=device-width, initial-scale=0.5" />} */}
      </Helmet>
      <AdminNavbar
        userInfo={authInfo}
        routes={routes}
        handleDrawerToggle={handleDrawerToggle}
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <Box display="flex" width="100%" >
        <AdminSideBar
          routes={routes.filter((item) => item.layout === "/admin")}
          logoText={t("app.name")}
          handleDrawerToggle={handleDrawerToggle}
          open={mobileOpen}
          color="violet"
          isMobile={isMobile}
          setMobileOpen={setMobileOpen}
        />
        <Box flex="1 auto" overflow={pathname.includes('jobs/create') || pathname.includes('jobs/detail') ? 'unset' : 'hidden'} height="fit-content" style={{
          opacity: mobileOpen && isMobile ? 0.5 : 1
        }}>
          <div
            className={classNames({
              [classes.mainPanel]: true,
            })}
          >
            {switchRoutes}
          </div>
        </Box>
      </Box>
    </PerfectScrollbar>
  );
};

export default Admin;
